import $x from '@/utils/$x';

export const queryExternalProductList = async (params) => {
  return $x.post('/enterprise/goods/page', {
    requestData: {},
    page: {
      currentPage: params.current || 1,
      pageSize: params.pageSize || 10,
    },
  });
};

export const deleteExternalProduct = async (id) => {
  return $x.post('/enterprise/goods/del', {
    requestData: {
      id: Number(id),
    },
  });
};

export const getExternalProductDetail = async (id) => {
  return $x.post('/enterprise/goods/details', {
    requestData: {
      id: Number(id),
    },
  });
};

export const saveExternalProduct = async (data) => {
  return $x.post('/enterprise/goods/saveOrUpdate', {
    requestData: data,
  });
};

export const searchEnterprise = async (id) => {
  return $x.post('/enterprise/searchEnterprise', {
    requestData: {
      id: Number(id),
    },
  });
};
